import React, { useEffect, useState } from "react";
import axios from "axios";
import propTypes from "prop-types";
import { pathwaySubPathwayList } from "apiServices/app";
import ButtonComponent from "components/FormsComponents/ButtonComponent";
import TextBoxComponent from "components/FormsComponents/TextBoxComponent";
import MultiSelectDropdown from "components/FormsComponents/MultiSelectDropdown";
import classNames from "classnames";
import { FaSearch } from "react-icons/fa";
import { getStorageData, setStorageData } from "utils/helper";
import {
  CountySvgIcn,
  KeywordsSvgIcn,
  OrgNameSvgIcn,
  PathwaySvgIcn,
  SpathwaySvgIcn,
} from "svgIcon";
import { Container } from "react-bootstrap";
import { useStyles } from "./styles";

const TopHeaderSearchComponents = (props) => {
  const classes = useStyles(props);
  const {
    formData,
    setFormData,
    onSearchClick,
    className,
    searchStatus = false,
    setSearchStatus,
    isPage = false,
  } = props;
  const pathway_option = getStorageData("pathway_option");
  const [pathwayData, setPathWayData] = useState(
    pathway_option && Object.keys(pathway_option).length > 0
      ? pathway_option
      : []
  );

  const sub_pathway_option = getStorageData("sub_pathway_option");
  const [subCategoryData, setSubCategoryData] = useState(
    sub_pathway_option && Object.keys(sub_pathway_option).length > 0
      ? sub_pathway_option
      : []
  );

  const keyword_option = getStorageData("keyword_option");
  const [keywordData, setKeywordData] = useState(
    keyword_option && Object.keys(keyword_option).length > 0
      ? keyword_option
      : []
  );

  const county_option = getStorageData("county_option");
  const [countyData, setCountyData] = useState(
    county_option && Object.keys(county_option).length > 0 ? county_option : []
  );
  const [allData, setAllData] = useState({
    pathway: [],
    sub_pathway: [],
    keyword: [],
    county: [],
  });
  const handleInput = ({ target: { name, value } }) => {
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const getSearchAllData = () => {
    let sourceToken = axios.CancelToken.source();
    pathwaySubPathwayList(
      {
        status: true,
      },
      sourceToken
    )
      .then(({ data, success }) => {
        if (success === "true") {
          //set pathway data
          let result_pathway = responseFormate(data.pathway);
          setPathWayData(result_pathway);
          setStorageData("pathway_option", result_pathway);

          //set sub pathway data
          let result_sub_pathway = responseFormate(data.sub_pathway);
          //set keyword data
          let result_keyword = responseFormate(data.keyword);
          // setKeywordData(result_keyword);

          //set county data
          let result_county = responseFormate(
            data?.county?.length ? data.county : []
          );
          setCountyData(result_county);
          setStorageData("county_option", result_county);
          //Set First time all Data store
          setAllData({
            pathway: result_pathway,
            sub_pathway: result_sub_pathway,
            keyword: result_keyword,
            county: result_county,
          });
          const result_target = data?.target_group?.length
            ? data.target_group.map((val, i) => {
                return {
                  value: val.id,
                  label: val.name,
                  text: val.name,
                };
              })
            : [];
          const local_authority = data?.local_authority;
          setStorageData("target_option", result_target);
          setStorageData("local_authority", local_authority);
        }
      })
      .catch((error) => {})
      .finally();
    return () => sourceToken.cancel();
  };

  const responseFormate = (data) => {
    const result = data.map((val, i) => {
      return {
        value: val.id,
        label: val.name,
        data: val,
      };
    });
    return result;
  };

  const pathwayToFetchSubKeyData = (
    name,
    selected = [],
    selectedlabel = []
  ) => {
    setSearchStatus(false);
    var name_append = name + "_name";
    let select_field = { [name]: selected, [name_append]: selectedlabel };
    if (name === "pathway") {
      let sub_pathway = [];
      let sub_pathway_name = [];
      formData?.sub_pathway_name &&
        formData.sub_pathway_name.map((item, i) => {
          if (selected.includes(item.data.pathway_id)) {
            sub_pathway_name = [...sub_pathway_name, item];
            sub_pathway = [...sub_pathway, item.value];
          }
        });

      let keyword = [];
      let keyword_name = [];

      formData?.keyword_name &&
        sub_pathway.length &&
        formData.keyword_name.map((item, i) => {
          if (
            selected.includes(item.data.pathway_id) ||
            sub_pathway.includes(item.data.sub_pathway)
          ) {
            keyword_name = [...keyword_name, item];
            keyword = [...keyword, item.value];
          }
        });

      select_field = {
        ...select_field,
        sub_pathway: sub_pathway,
        sub_pathway_name: sub_pathway_name,
        keyword: keyword,
        keyword_name: keyword_name,
      };
      //Select pathway to fetch sub-pathways
      let newSubCat = allData?.sub_pathway
        ? allData.sub_pathway.filter((item, i) =>
            selected.includes(item.data.pathway_id)
          )
        : [];
      setSubCategoryData(newSubCat);
      setStorageData("sub_pathway_option", newSubCat);
      setStorageData("keyword_option", []);
    } else if (name === "sub_pathway") {
      //Select Sub pathway to fetch Keyword
      let keyword = [];
      let keyword_name = [];

      formData?.keyword_name &&
        selected.length &&
        formData.keyword_name.map((item, i) => {
          if (
            formData.pathway.includes(item.data.pathway_id) ||
            selected.includes(item.data.sub_pathway)
          ) {
            keyword_name = [...keyword_name, item];
            keyword = [...keyword, item.value];
          }
        });
      select_field = {
        ...select_field,
        keyword: keyword,
        keyword_name: keyword_name,
      };
      let newKeyword = allData?.keyword
        ? allData.keyword.filter(
            (item, i) =>
              formData.pathway.includes(item.data.pathway_id) ||
              selected.includes(item.data.sub_pathway)
          )
        : [];
      setKeywordData(newKeyword);
      setStorageData("keyword_option", newKeyword);
    }
    setFormData({
      ...formData,
      ...select_field,
    });
  };

  const handleResetFilter = () => {
    setFormData({
      ...formData,
      pathway: [],
      pathway_name: [],
      sub_pathway: [],
      sub_pathway_name: [],
      keyword: [],
      keyword_name: [],
      county: [],
      county_name: [],
      name: "",
      is_clinks: false,
    });
  };

  useEffect(() => {
    getSearchAllData();
  }, []);

  return (
    <>
      <div
        className={classNames(
          classes.search__form,
          "search__formCommon position-relative",
          className
        )}
      >
        <Container fluid="xxl">
          <div className="form__row d-flex flex-wrap align-items-center w-100">
            <div className="fr__items position-relative fr__pathway">
              <div className="fr__ibox d-flex align-items-center">
                <PathwaySvgIcn
                  className="me-2"
                  style={{ width: "15px", height: "17px", flex: "0 0 15px" }}
                />
                <MultiSelectDropdown
                  name="pathway"
                  selected={formData && formData.pathway}
                  options={pathwayData.sort((a, b) =>
                    a.label.localeCompare(b.label)
                  )}
                  formData={formData}
                  setFormData={setFormData}
                  pathwayToFetchSubKeyData={pathwayToFetchSubKeyData}
                  title="Fields of work"
                  placeholder={
                    <span className="grop__placeholder d-block w-100 text-start">
                      Fields of work
                    </span>
                  }
                />
              </div>
            </div>
            <div className="fr__items position-relative fr__spathway">
              <div className="fr__ibox d-flex align-items-center">
                <SpathwaySvgIcn
                  className="me-2"
                  style={{ width: "17px", height: "18px", flex: "0 0 17px" }}
                />
                <MultiSelectDropdown
                  name="sub_pathway"
                  selected={formData && formData.sub_pathway}
                  options={subCategoryData.sort((a, b) =>
                    a.label.localeCompare(b.label)
                  )}
                  formData={formData}
                  setFormData={setFormData}
                  pathwayToFetchSubKeyData={pathwayToFetchSubKeyData}
                  disabled={
                    formData && formData.pathway && formData.pathway.length
                      ? false
                      : true
                  }
                  title="Sub-pathway"
                  placeholder={
                    <span className="grop__placeholder d-block w-100 text-start">
                      Sub-pathway
                    </span>
                  }
                />
              </div>
            </div>
            <div className="fr__items position-relative fr__keyword">
              <div className="fr__ibox d-flex align-items-center">
                <KeywordsSvgIcn
                  className="me-2"
                  style={{ width: "20px", height: "20px", flex: "0 0 20px" }}
                />
                <MultiSelectDropdown
                  name="keyword"
                  selected={formData && formData.keyword}
                  options={keywordData.sort((a, b) =>
                    a.label.localeCompare(b.label)
                  )}
                  disabled={
                    formData &&
                    formData.sub_pathway &&
                    formData.sub_pathway.length
                      ? false
                      : true
                  }
                  formData={formData}
                  setFormData={setFormData}
                  title="Keyword"
                  placeholder={
                    <span className="grop__placeholder d-block w-100 text-start">
                      Keyword
                    </span>
                  }
                />
              </div>
            </div>
            <div className="fr__items position-relative fr__county">
              <div className="fr__ibox d-flex align-items-center">
                <CountySvgIcn
                  className="me-2"
                  style={{ width: "20px", height: "20px", flex: "0 0 20px" }}
                />
                <MultiSelectDropdown
                  name="county"
                  selected={formData && formData.county}
                  options={countyData}
                  // disabled={
                  //   formData && formData.pathway && formData.pathway.length
                  //     ? false
                  //     : true
                  // }
                  formData={formData}
                  setFormData={setFormData}
                  title="County"
                  placeholder={
                    <span className="grop__placeholder d-block w-100 text-start">
                      County
                    </span>
                  }
                />
                {/* <TextBoxComponent
                  name="county"
                  value={formData && formData.county}
                  title="County"
                  handleInput={handleInput}
                  placeholder="County"
                /> */}
              </div>
            </div>
            <div className="fr__items position-relative fr__orgname">
              <div className="fr__ibox d-flex align-items-center">
                <OrgNameSvgIcn
                  className="me-2"
                  style={{ width: "20px", height: "20px", flex: "0 0 20px" }}
                />
                <TextBoxComponent
                  name="name"
                  className="p-0 border-0"
                  value={formData && formData.name}
                  title="Organisation Name"
                  handleInput={handleInput}
                  placeholder="Organisation Name"
                />
              </div>
            </div>
            <div className="fr__items fr__action">
              <div className="fr__ibox d-flex align-items-center">
                <ButtonComponent
                  variant="dark"
                  children={"Search"}
                  title="Search"
                  isIcon={<FaSearch className="me-2" />}
                  onClick={onSearchClick}
                />
              </div>
            </div>
          </div>
        </Container>
        {isPage === "home" &&
        formData &&
        (formData.pathway?.length ||
          formData.county?.length ||
          formData.name) ? (
          <div className="error__msg mb-0 text-white text-end pe-4">
            <span
              onClick={handleResetFilter}
              style={{ cursor: "pointer", textDecoration: "underline" }}
              role="button"
            >
              Remove all filters
            </span>
          </div>
        ) : (
          ""
        )}
        {searchStatus ? (
          <div className="error__msg mb-0 text-danger text-center">
            Oops! You need to select a fields of work / county or search
            organisation name first.
          </div>
        ) : (
          ""
        )}
      </div>
    </>
  );
};
TopHeaderSearchComponents.propTypes = {
  history: propTypes.object,
};
export default TopHeaderSearchComponents;
